import {
  chatWidgetOnLoadCallbackVar,
  shouldLoadChatWidgetScriptVar,
} from '@fdc/components/global-state/chat-widget';

export const openChatWidget = () => {
  if (window.chatWidget) {
    window.chatWidget.onStartChat({ setFullScreen: false });
  } else {
    chatWidgetOnLoadCallbackVar(() => {
      window.chatWidget?.onStartChat({ setFullScreen: false });
    });
    shouldLoadChatWidgetScriptVar(true);
  }
};
